// controllers
// import ScrollController from '../../../assets/js/controller/scroll';

// helpers
import { bindEvents } from '../../../assets/js/helpers';

const selector = 'loader-initial';

export default class LoaderInitial {

	constructor(section) {
		this.el = {
			section
		};

		// class variable groups

		this.config = {
			transition: {
				minTime: 2000,
				out: 400,
			}
		};

		this.flags = {
			isOut: true
		};

		this.states = {
			transition: {
				start: 0,
				end: 0
			}
		};

		// bind events to class scope
		this.events = bindEvents(this);
	}

	static get selector() {
		return selector;
	}

	show(isFirst = false) {
		return new Promise((resolve, reject) => {
			if (this.flags.isOut) {
				this.el.section.classList.remove('is-out', 'is-out-anim');
				this.el.section.classList.add('is-in');
				this.flags.isOut = false;

				this.states.transition.start = Date.now();
				this.states.transition.end = this.states.transition.start + this.config.transition.minTime;

				if (isFirst) {
					this.el.section.classList.add('is-in-first');
				}

				resolve();
			} else {
				reject();
			}
		});
	}

	hide() {
		return new Promise((resolve, reject) => {
			if (!this.flags.isOut) {
				this.flags.isOut = true;
				const timeRemaining = Math.max(0, this.states.transition.end - Date.now());

				setTimeout(() => {
					this.el.section.classList.remove('is-in', 'is-in-first');
					this.el.section.classList.add('is-out-anim');

					setTimeout(() => {
						this.el.section.classList.add('is-out');
						this.el.section.classList.remove('is-out-anim');
						this.flags.isAnimating = false;
						resolve();
					}, this.config.transition.out);

				}, timeRemaining);

			} else {
				reject();
			}
		});
	}

	destroy() {

	}

}
